<div [id]="id" class="content">
  <h2>Home</h2>
  <div class="card-button-container">
    @for (buttonSetting of buttonSettings; track buttonSetting; let i = $index) {
      <app-card-button
        class="card-button"
        [number]="i+1"
        [buttonSettings]="buttonSetting"
      ></app-card-button>
    }
    <app-card-button-word-download
      class="card-button"
      [number]="buttonSettings.length + 1"
    > </app-card-button-word-download>
  </div>
</div>
